import { cryptoOptions } from 'dexie-encrypted';

const IDBStoresUser = {
  user: 'id, email',
};

const IDBEncryptedStoresUser = {
  user: cryptoOptions.NON_INDEXED_FIELDS,
};

const IDBStoresData = {
  institution: 'id',
  student: 'idAlumno, idTutor',
  menu: 'id++',
  path: 'id++, idAlumno',
  digitalFile: '&[idAlumno+idDocumento], idAlumno, idDocumento',
  digitalFile_files: '&[idAlumno+idDocumento], idAlumno, idDocumento',
  sync: 'id++, [idAlumno+tipo], idAlumno, tipo',
  notifications: 'idNotificacion, idUsuario, &[idNotificacion+idUsuario]',
  schoolarships: '&[idInstitucion+idDocumento], idInstitucion, idDocumento',
  schoolarships_files:
    '&[idInstitucion+idDocumento], idInstitucion, idDocumento',
};

const IDBEncryptedStoresData = {
  institution: cryptoOptions.NON_INDEXED_FIELDS,
  student: cryptoOptions.NON_INDEXED_FIELDS,
  menu: cryptoOptions.NON_INDEXED_FIELDS,
  path: cryptoOptions.NON_INDEXED_FIELDS,
  digitalFile: cryptoOptions.NON_INDEXED_FIELDS,
  digitalFile_files: cryptoOptions.NON_INDEXED_FIELDS,
  sync: cryptoOptions.NON_INDEXED_FIELDS,
  notifications: cryptoOptions.NON_INDEXED_FIELDS,
  schoolarships: cryptoOptions.NON_INDEXED_FIELDS,
  schoolarships_files: cryptoOptions.NON_INDEXED_FIELDS,
};

export {
  IDBStoresUser,
  IDBEncryptedStoresUser,
  IDBStoresData,
  IDBEncryptedStoresData,
};
